import App from '@/app/App';
import * as Sentry from '@sentry/react';
import * as ReactDOM from 'react-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { store } from './reducers/store';

Sentry.init({
  dsn: process.env.VITE_SENTRY_DSN,
  environment: process.env.VITE_enviroment,
});

const persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <Sentry.ErrorBoundary>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Sentry.ErrorBoundary>
  </Provider>,
  document.getElementById('app'),
);
